import SynchronizationOffline from './SynchronizationOffline';

export default SynchronizationOffline;